<template>
  <div class="construction-window">
    <el-dialog title="延伸预报" :visible.sync="params.flag" v-dialogDrag :modal="false" :close-on-click-modal="false"
      :lock-scroll="false" :modal-append-to-body=false ref="cxtjRef"
      :before-close="() => params.flag && $parent.toggleProductView(params.productInfo.code)">
      <div slot="title" class="select-header">
        <div class="name">
          <span>延伸预报</span>
          <div class="image">
            每周二和每周五更新数据
          </div>
        </div>
        <div class="tu-time">
          更新时间:{{ $moment(publicTime).format('YYYY年MM月DD日HH时mm分') }}
        </div>
      </div>
      <div class="window-content">
        <div class="left">
          <div v-for="item in leftTitles" :key="item">
            <span>{{ item }}</span>
          </div>
        </div>
        <div class="right" ref="moveRef">
          <div class="right-box" ref="scrollRef">
            <div class="right-item">
              <span v-for="item, index in times" :key="index">{{ item }}</span>
            </div>
            <div class="right-item">
              <span
                :class="rainlevel[index] === 1 ? 'xiao' : rainlevel[index] === 2 ? 'zhong' : rainlevel[index] === 3 ? 'da' : ''"
                v-for="item, index in weather" :key="index">{{ item }}</span>
            </div>
            <div class="right-item">
              <span
                :class="rainlevel[index] === 1 ? 'xiao' : rainlevel[index] === 2 ? 'zhong' : rainlevel[index] === 3 ? 'da' : ''"
                v-for="item, index in wind" :key="index">{{ item }}</span>
            </div>
            <div class="echart" ref="echartRef">

            </div>
          </div>
          <!-- <div class="btn-icon">
            <img src="@/assets/images/左滑.png" alt="" @click="goLeftOrRight('right')">
            <img src="@/assets/images/右滑.png" alt="" @click="goLeftOrRight('left')">
          </div> -->
        </div>
      </div>
      <div class="window-tuli">
        <div class="tu-title">图例：</div>
        <div class="tu-item">
          <span></span>小雨
        </div>
        <div class="tu-item">
          <span></span>中雨
        </div>
        <div class="tu-item">
          <span></span>大雨
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import echarts from '@/config/echarts/index.js'
import { getContructionWindowOption } from '@/config/echarts/option/construction-window'
import { mapState } from 'vuex'
import { apiData } from '@/api'
export default {
  props: ['params'],
  data () {
    return {
      leftTitles: ['日期', '天气状况', '风力', '最高温度', '最低温度'],
      times: ['5日', '6日', '7日', '8日', '9日', '10日'],
      weather: ['多云转晴', '多云转晴', '多云转晴', '多云转晴', '多云转晴', '多云转晴'],
      maxt: [],
      mint: [],
      rainlevel: [],
      wind: [],
      publicTime: ''
    }
  },
  watch: {
    activeCountyId: {
      handler (id) {
        this.getData(id)
      },
      immediate: true
    },
    'params.flag': {
      handler (flag) {
        flag && this.setZindex()
      },
      immediate: true
    }
  },
  computed: {
    ...mapState('home', ['activeCountyId', 'objsList'])
  },
  mounted () {
    this.$nextTick(() => {
      this.initEchart()
      this.addMouseMove()
    })
    window.addEventListener('resize', () => {
      this.$nextTick(() => this.myEchart.resize())
    })
  },
  methods: {

    initEchart () {
      this.myEchart = echarts.init(this.$refs.echartRef)
      const option = getContructionWindowOption()
      this.myEchart.setOption(option)
    },

    async getData (id) {
      const item = this.objsList.find(item => item.id === id)
      const lon = (Math.round(item.lon / 0.5) * 0.5).toFixed(2).replace(/\./g, '')
      const lat = (Math.round(item.lat / 0.5) * 0.5).toFixed(2).replace(/\./g, '')
      const result = await apiData.getecDaily(lon, lat)
      const timeOut = Date.now() + 86400000 * 7
      const day = this.$moment(timeOut).format('MM月DD日')
      let index = result.datedec.findIndex(item => item === day)
      if (!index) {
        index = 0
      }
      this.times = result.datedec.slice(index)
      this.weather = result.desc.slice(index)
      this.maxt = result.maxt.slice(index)
      this.mint = result.mint.slice(index)
      this.rainlevel = result.rainlevel.slice(index)
      this.wind = result.wind.slice(index)
      this.publicTime = result.ptimestemp

      const moveWidth = this.$refs.moveRef.offsetWidth / 12
      this.$refs.scrollRef.style.width = moveWidth * this.times.length + 'px'
      this.$nextTick(() => {
        if (!this.myEchart) {
          this.myEchart = echarts.init(this.$refs.echartRef)
        }

        this.option = getContructionWindowOption(this.$refs.moveRef.offsetWidth / 24)
        this.option.xAxis.data = this.times
        this.option.yAxis.max = Math.max(...this.maxt)
        this.option.yAxis.min = Math.min(...this.mint)
        this.option.series[0].data = this.maxt
        this.option.series[1].data = this.mint
        this.myEchart.setOption(this.option)
        this.myEchart.resize()
      })
    },

    addMouseMove () {
      const moveRef = this.$refs.moveRef
      const scrollRef = this.$refs.scrollRef
      let start = 0
      let end = 0
      let scrollLeft = 0
      scrollRef.onmousedown = (e) => {
        start = e.clientX
        scrollLeft = moveRef.scrollLeft
      }
      scrollRef.onmouseup = (e) => {
        end = e.clientX
        console.log(start, end)
        let left = 0
        if (start > end) {
          left = scrollLeft + moveRef.offsetWidth
        } else {
          left = scrollLeft - moveRef.offsetWidth
        }
        console.log(left)
        moveRef.scrollTo({
          left,
          behavior: 'smooth'
        })
      }
    },

    goLeftOrRight (type) {
      const el = this.$refs.scrollRef
      const moveWidth = this.$refs.moveRef.offsetWidth
      const left = el.style.left ? Number(el.style.left.replace('px', '')) : 0
      const totalwidth = el.offsetWidth - moveWidth
      const leftWidth = left * -1 + 15
      if (type === 'left') {
        const leftWidth = left * -1 + 15
        if (leftWidth < totalwidth) {
          el.style.left = left - 1 * moveWidth + 'px'
        }
      } else {
        if (leftWidth > moveWidth) {
          el.style.left = left + 1 * moveWidth + 'px'
        }
      }
    },

    // 设置弹出框的zIndex
    setZindex () {
      this.$nextTick(() => {
        const el = this.$refs.cxtjRef
        let zIndex = JSON.parse(localStorage.getItem('dialogZIndex'))
        zIndex = zIndex * 1 + 1
        el.$el.style.zIndex = zIndex
        localStorage.setItem('dialogZIndex', JSON.stringify(zIndex))
      })
    }
  }
}
</script>
<style lang="less" scoped>
.construction-window {
  display: flex;
  flex-direction: column;
  pointer-events: none;

  .select-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-right: 2.6vw;
    font-size: 0.94vw;
    font-weight: 600;
    color: #FFF;
    line-height: 1.3vw;

    .name {
      display: flex;
      align-items: center;
    }

    .tu-time {
      font-size: 0.73vw;
      font-weight: 400;
      color: #FFF;
    }

    .image {
      margin-left: 0.94vw;
      font-size: 0.73vw;
      font-weight: 400;
      color: #FFFFFF;
    }
  }

}

.window-content {
  display: flex;
  flex: 1;

  .left {
    display: flex;
    flex-direction: column;
    width: 7.29vw;
    height: 100%;
    background: #3C7CB8;

    div {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 3.07vw;
      font-size: 0.73vw;
      font-weight: 500;
      color: #FFF;
    }

    div:nth-child(4),
    div:nth-child(4) {
      flex: 1;
    }
  }

  .right {
    display: flex;
    flex-direction: column;
    flex: 1;
    position: relative;
    overflow: hidden;
    overflow-x: auto;

    .btn-icon {
      display: flex;
      justify-content: space-between;
      position: absolute;
      top: 46%;
      width: 100%;
      box-sizing: border-box;
      padding: 0px 0 0 10px;
      height: 1.93vw;

      img {
        height: 1.93vw;
        cursor: pointer;
      }
    }

    .right-box {
      display: flex;
      flex-direction: column;
      position: absolute;
      left: -0px;
      min-width: 100%;
      height: 100%;
    }

    .right-item {
      display: flex;
      height: 3.07vw;

      span {
        flex: 1;
        text-align: center;
        line-height: 3.07vw;
      }

      span.sg {
        background: #E9FFE0;
      }

      span.xiao {
        background: #FCFC52;
        ;
      }

      span.zhong {
        background: #FEA100;
        ;
      }

      span.da {
        background: #E7023B;
      }
    }

    .right-item:nth-child(1) {
      background: #3C7CB8;
      color: #FFF;
    }

    .echart {
      flex: 1;
    }
  }
}

.window-tuli {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 3.54vw;
  font-size: 0.68vw;
  color: #FFF;

  .tu-title {
    font-size: 0.83vw;
    font-weight: 600;
  }

  span {
    display: inline-block;
    width: 1.51vw;
    height: 0.78vw;
    border-radius: 0.21vw;
    margin: 0vw 0.5vw 0vw 1.25vw;
  }
}

.tu-item {
  display: flex;
  align-items: center;
}

.tu-item:nth-child(2) span {
  background: #FCFC52;
}

.tu-item:nth-child(3) span {
  background: #FEA100;
}

.tu-item:nth-child(4) span {
  background: #E7023B;
}

.tu-item:nth-child(5) span {
  background: #E9FFE0;
}

::-webkit-scrollbar {
  height: 0.32vw;
}

::-webkit-scrollbar-track {
  background: #1F2C49;
  border-radius: 1.09vw;
}

::-webkit-scrollbar-thumb {
  background: #405176;
  border-radius: 1.09vw;
  height: 1.56vw;
}

/deep/.el-dialog__wrapper {
  overflow: hidden;

  .el-dialog {
    width: 62.08vw;
    height: 29.11vw;
    border-radius: 0.63vw;
    pointer-events: auto;
  }
}</style>
